export function callbackOnWidthChange(oldWidth, callback) {
    if (window.innerWidth !== oldWidth) {
        callback(window.innerWidth);
    }
}
